import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider from '../../shared/context/GetAllColumnContext';
import { t } from '../../i18next';
import GridWrapper from '../../shared/components/grid/GridWrapper';
import { useAllScreensContext } from '../../shared/context/AllScreensDetailsContext';
import { useNavigate, useParams } from 'react-router';

const NpiDefaultScreen = () => {
  const { menuGroup } = useAllScreensContext();
  const { screenId } = useParams();
  const navigate = useNavigate();
  const { loading, error, screenTables } = useFetchScreenDetails(screenId);
  const nonAdminScreeens = menuGroup
    .filter((item) => item.appName !== 'NPI Tool Administration')
    .find((item) => item.subMenu.find((i) => i.appNameId === screenId));
  if (!nonAdminScreeens && !loading) {
    navigate('/404');
    return;
  }

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <GridWrapper tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default NpiDefaultScreen;
